export default __webpack_public_path__ + "static/media/seg-0-app.36a6382b.png";